<script setup lang="ts">

import ThePremium from '@/components/ThePremium.vue'
import { computed } from 'vue'
import { usePlayer } from '@/composables/game/player'
import { formatNumberFullTruncate } from '@/helpers/utils'
import { RouteName } from '@/routes'
import { DAILY_TASK_ID } from '@/types/shared/player'
import { twMerge } from 'tailwind-merge'
import { T } from '@tolgee/vue'
import ExplodeEmojisAnimation from '@/components/ExplodeEmojisAnimation.vue'
import TelegramStar from '@/assets/images/premium.png'

withDefaults(defineProps<{
  wrapperClass?: string
  pillClass?: string
  showStarAnimation?: boolean
}>(), {
  wrapperClass: '',
  pillClass: '',
  showStarAnimation: false,
})

const { player } = usePlayer()
const balance = computed(() => player.value.ecommerce.starsBalance)

</script>

<template>
  <div :class="twMerge('flex flex-col gap-y-1', wrapperClass)">
    <div class="px-0.5 text-light-white text-xs font-semibold -tracking-[0.24px]">
      <T
        key-name="stars.dropee_balance"
        default-value="Stars Balance"
      />
    </div>
    <VTooltip
      placement="right"
      popper-class="stars-balance-tooltip"
      class="max-w-fit"
    >
      <div
        :class="twMerge('flex items-center gap-x-1.5 py-1.5 pl-2.5 pr-3 rounded-full bg-dark-top-layer max-w-fit', pillClass)"
      >
        <div class="relative">
          <ThePremium
            :with-tooltip="false"
            class="size-4 min-w-[16px]"
          />
          <ExplodeEmojisAnimation
            :show="showStarAnimation"
            :image-src="TelegramStar"
            image-rotate-angle="200deg"
            :count="5"
          />
        </div>
        <span
          class="text-light-white text-sm font-semibold -tracking-[0.28px]"
        >{{ formatNumberFullTruncate(balance) }}</span>
      </div>
      <template #popper>
        {{ "Go to this" }}
        <RouterLink
          class="underline text-teal-primary"
          :to="{name: RouteName.EARN, query: { openTaskId: DAILY_TASK_ID.BUY_STARS } }"
        >
          {{ 'quest' }}
        </RouterLink>
        {{ 'to top up your Stars Balance' }}
      </template>
    </VTooltip>
  </div>
</template>

<style lang="scss">

.stars-balance-tooltip.v-popper--theme-tooltip {

  .v-popper__inner {
    @apply text-left whitespace-pre #{!important};
  }
}
</style>
